export default {
  data() {
    return {
      rulesList: [
        {
          name: "個人賽 比賽章程 ",
          url:
            "https://materialv3-1256597606.cos.accelerate.myqcloud.com/chineserd/dev/2025-12/754d84035033004fb32b6085a3c084de.pdf",
        },
        // {
        //   name: "團體賽 比賽章程 ",
        //   url:
        //     "",
        // },
      ],
      //  app下载
      appUrl: "https://app.chineserd.com",
      // 赛事质询
      whatUrl: "https://wa.me/85291496563",
      // h5banner
      h5BannerUrl: require("@/assets/image/hodgepodge/h5banner.jpg"),
      // pcbanner
      pcBannerUrl: require("@/assets/image/hodgepodge/pcbanner.jpg"),
    };
  },
  computed: {},
  components: {},
  watch: {},
  created() {},
  mounted() {
    
  },
  methods: {},
};
